import { FinnairOrder } from '@fcom/dapi/api/models';
import { TzDate } from '@fcom/utils';

/**
 * Get first eligible boundIndex for disruption handling and startDate to show alternative-offers
 * @param order
 * @return [startDate, eligibleBoundIndex]
 */
export const getEligibleBoundIndexAndStartDate = (order: FinnairOrder): [string, number] => {
  const eligibility = order.eligibilities.disruptionRebooking.find((eligibility) => eligibility.isAllowedToUse);
  const eligibleBoundIndex = order.bounds.findIndex((b) => b.id === eligibility?.id);
  const bound = order.bounds[eligibleBoundIndex]?.disruptedBound?.disruptedBound ?? order.bounds[eligibleBoundIndex];
  const originalLocalDate = TzDate.of(bound?.departure.dateTime)?.toLocalDate();
  const isOriginalDateEligible =
    eligibility?.eligibleDateRanges?.some((range) =>
      originalLocalDate.isBetween(
        TzDate.of(range.fromDateTime).toLocalDate(),
        TzDate.of(range.toDateTime).toLocalDate()
      )
    ) ?? false;
  const startDate = isOriginalDateEligible
    ? originalLocalDate.toString()
    : TzDate.of(eligibility?.eligibleDateRanges?.[0]?.fromDateTime)
        ?.toLocalDate()
        .toString() ??
      originalLocalDate?.toString() ??
      '';
  return [startDate, eligibleBoundIndex];
};
